// third-party
import { IconMicroscope } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconMicroscope,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const labManagement = {
    id: 'Lab Management',
    title: <FormattedMessage id="Lab Management" />,
    icon: icons.IconMicroscope,
    type: 'group',
    children: [
        {
            id: 'Lab Records',
            title: <FormattedMessage id="Lab Records" />,
            type: 'item',
            url: '/lab-records/list',
            icon: icons.IconMicroscope,
            breadcrumbs: false
        },
    ]
};

export default labManagement;